var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"bg":"","fill-height":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_vm._v("Chargement en cours... "),_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }